import React from 'react'
import { Route, Switch } from 'react-router-dom'

import DealsContainer from '../deals'
import UserManagement from '../userManagement'
import PayloadContainer from '../payout'
// import BookingContainer from '../bookings'
// import AmenitiesContainer from '../amenities'
// import RatingReviewContainer from '../ratingReview'
import ETMTicketsContainer from '../etmTickets'
import BusServiceInfoContainer from '../busServiceInfo'
import DashboardContainer from '../dashboard'
import DriverDetailsContainer from '../driverDetails'
import InventoryRefreshContainer from '../inventoryRefresh'
import CancellationOffersContainer from '../cancellationOffers'
import RatingsReviewsContainer from '../ratingsReviews'
import InventoryViewContainer from '../inventoryView'
import RestStopConfiguration from '../restStopConfiguration'

import { routePrefix } from '../../config';
import UnReviewedOrders from '../ratingsReviews/UnReviewedOrders/UnReviewedOrders'

export default () => (
  <Switch>
    <Route exact path={routePrefix+'/user-management'} component={UserManagement} />
    {/*<Route exact path='/bookings' component={BookingContainer} />*/}
    {/*<Route exact path='/amenities' component={AmenitiesContainer} />*/}
    {/*<Route exact path='/rating-review' component={RatingReviewContainer} />*/}
    <Route path={routePrefix + '/deals'} component={DealsContainer} />
    <Route path={routePrefix + '/etm-tickets'} component={ETMTicketsContainer} />
    <Route path={routePrefix + '/bus-service-info'} component={BusServiceInfoContainer} />
    <Route path={routePrefix + '/payout'} component={PayloadContainer} />
    <Route path={routePrefix + '/driver-details'} component={DriverDetailsContainer} />
    <Route path={routePrefix + '/inventory-refresh'} component={InventoryRefreshContainer} />
    <Route path={routePrefix + '/cancellation-offer'} component={CancellationOffersContainer} />
    <Route exact path={routePrefix + '/ratings-reviews/askForReview'} component={UnReviewedOrders} />
    <Route path={routePrefix + '/ratings-reviews'} component={RatingsReviewsContainer} />
    <Route path={routePrefix + '/inventory-view'} component={InventoryViewContainer} />
    <Route path={routePrefix + '/restStop-configuration'} component={RestStopConfiguration} />
    <Route path={'/'} component={DashboardContainer} />
  </Switch>
)
